/**
 * Product grid filters: filtering happens in the browser against tags already
 * on each card, so switching between them costs no page load.
 */
class ProductGrid extends HTMLElement {
  connectedCallback() {
    this.filters = this.querySelectorAll('[data-filter]');
    this.cards = this.querySelectorAll('[data-tags]');
    if (!this.filters.length) return;

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter]');
      if (!button) return;
      this.apply(button);
    });

    this.rail = this.querySelector('[data-filter-rail]');
    if (this.rail) {
      this.updateRail();
      this.rail.addEventListener('scroll', () => this.updateRail(), { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => this.updateRail()).observe(this.rail);
      }
    }
  }

  /**
   * Fades the rail's edges only where there is more to scroll to, so the cue is
   * honest: no fade means nothing is hidden.
   */
  updateRail() {
    const rail = this.rail;
    const max = rail.scrollWidth - rail.clientWidth;
    rail.classList.toggle('has-start', rail.scrollLeft > 2);
    rail.classList.toggle('has-end', rail.scrollLeft < max - 2);
  }

  apply(button) {
    const tag = (button.dataset.filter || '').toLowerCase();

    this.filters.forEach((f) => {
      const on = f === button;
      f.classList.toggle('is-active', on);
      f.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    let shown = 0;
    this.cards.forEach((card) => {
      const tags = (card.dataset.tags || '').toLowerCase().split(',').map((t) => t.trim());
      const match = !tag || tags.includes(tag);
      card.hidden = !match;
      if (match) shown += 1;
    });

    const empty = this.querySelector('[data-empty]');
    if (empty) empty.hidden = shown > 0;

    // Announce the result, since the change is purely visual otherwise.
    const status = this.querySelector('[data-status]');
    if (status) status.textContent = `${shown} ${shown === 1 ? 'product' : 'products'} shown`;
  }
}

if (!customElements.get('product-grid')) {
  customElements.define('product-grid', ProductGrid);
}
